import React from 'react';
import PropTypes from 'prop-types';

import {styled} from '@mui/system';

const StyledList = styled('ul')({
    listStyleType: 'none',
    margin: 0,
    padding: 0
});


class AffiliationList extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <StyledList>
                {this.props.affiliations.map((affiliation, index) =>
                    <li key={index} title={affiliation.label}>
                        * {affiliation.name}
                    </li>
                )}
            </StyledList>
        );
    }

}

AffiliationList.propTypes = {
    affiliations: PropTypes.array
};

export default AffiliationList;
